import { languages } from '@/locales/index.js';
import Vue from 'vue';

const locale = Vue.prototype.$locale;

const workerDashboardSidebar = [
  {
    linkName: languages[locale].workerDashboard.sidebar.resume,
    linkIcon: 'EditIcon',
    styleClasses: 'text-primary',
    routeName: 'worker-dashboard'
  },
  {
    linkName: languages[locale].workerDashboard.sidebar.profile,
    linkIcon: 'HomeIcon',
    styleClasses: 'text-primary',
    routeName: 'worker-profile'
  },
  {
    linkName: languages[locale].workerDashboard.sidebar.settings,
    linkIcon: 'SettingsIcon',
    styleClasses: 'text-gray-500 cursor-not-allowed hidden',
    routeName: ''
  }
];

const workerDashboardSteps = [
  {
    name: languages[locale].workerDashboard.stepper.worker.profile
  },
  {
    name: languages[locale].workerDashboard.stepper.worker.info
  },
  {
    name: languages[locale].workerDashboard.stepper.worker.educations
  },
  {
    name: languages[locale].workerDashboard.stepper.worker.skills
  },
  {
    name: languages[locale].workerDashboard.stepper.worker.experiences
  },
  {
    name: languages[locale].workerDashboard.stepper.worker.vehicles
  },
  {
    name: languages[locale].workerDashboard.stepper.worker.about
  },
  {
    name: languages[locale].workerDashboard.stepper.worker.contract
  }
];

const employerDashboardSidebar = [
  {
    linkName: languages[locale].employerDashboard.sidebar.company,
    linkIcon: 'BriefcaseIcon',
    styleClasses: 'text-primary cursor-pointer',
    routeName: 'company-profile'
  },
  {
    linkName: languages[locale].employerDashboard.sidebar.job_descriptions,
    linkIcon: 'FolderIcon',
    styleClasses: 'text-primary cursor-pointer',
    routeName: 'job-offers'
  }
];

const employerDashboardSteps = [
  {
    name: languages[locale].employerDashboard.stepper.employer.profile
  },
  {
    name: languages[locale].employerDashboard.stepper.employer.vehicles
  },
  {
    name: languages[locale].employerDashboard.stepper.employer.missions
  },
  {
    name: languages[locale].employerDashboard.stepper.employer.skills
  },
  {
    name: languages[locale].employerDashboard.stepper.employer.specifications
  }
];

export const dashboards = {
  workerDashboardSidebar,
  workerDashboardSteps,
  employerDashboardSidebar,
  employerDashboardSteps
};
